















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { ModelSync } from 'vue-property-decorator'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import { PredefinedAnswerResourceModel } from '@/modules/predefined-answer/models/predefined-answer-resource.model'
import EmojiPickerButton from '@/modules/shared/components/shared/EmojiPickerButton.vue'

@Component({
  components: { EmojiPickerButton, BaseInput }
})
export default class AdminPredefinedAnswerForm extends Vue {

  @ModelSync('value', 'input') predefinedAnswer!: PredefinedAnswerResourceModel

  addEmoji(emoji) {
    this.predefinedAnswer.text = `${this.predefinedAnswer.text}${emoji.native}`
  }
}
